/**
 * Creates a object for every .Users DOM element.
 */
common.View.create('admin::user.CreateEdit', {

    onDOMLoad() {
        //this.manageRole();
    },

    // TODO Check this code. You may give roles and permissions you have, to lower or equal roles.
    manageRole() {
        // Determine if superadmin role is selected
        this.element.find('input[name="role"]').on('change', (event) => {

            $.post('/'+ ($('html').data('prefix') !== undefined ? $('html').data('prefix') : 'admin/') +'modules/users/role/' + event.currentTarget.value)
                .done((data) => {
                    // Remove all role disabled permissions
                    $('.userRights input').prop('disabled', false).parent().removeClass('role-disabled');

                    // Loop role permissions
                    $.each(data, (key, value) => {
                        // Get permission
                        let $permission = $('input[value="' + value.name + '"]');

                        // Set permission disabled because of role
                        if ($permission.length) {
                            $permission.prop('disabled', true).parent().addClass('role-disabled');
                        }
                    });
                });

            /** Hide/show rights by if is super admin checked.
            let superAdminChecked = parseInt($(event.currentTarget).val()) === 3;

            this.element.find('.userRights')
                .toggleClass('hidden', superAdminChecked)
                .end()

                // Hide/show context by if is super admin checked.
                .find('.userContexts')
                .toggleClass('hidden', superAdminChecked)
                .find('input[type="checkbox"]')
                .prop('disabled', function (i, v) {
                    return superAdminChecked;
                })
                .end();
             **/

        });
    }
});
